import { render, staticRenderFns } from "./cb.vue?vue&type=template&id=2ac7135b&scoped=true"
import script from "./cb.vue?vue&type=script&lang=js"
export * from "./cb.vue?vue&type=script&lang=js"
import style0 from "./cb.vue?vue&type=style&index=0&id=2ac7135b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac7135b",
  null
  
)

export default component.exports